import { Link2, Brain, Headphones } from "lucide-react";

const steps = [
  { icon: Link2, title: "Incolli il tuo sito", num: "01" },
  { icon: Brain, title: "L'AI studia la tua azienda", num: "02", animated: true },
  { icon: Headphones, title: "In 5 minuti la tua voce è online", num: "03" },
];

export default function Solution() {
  return (
    <section className="py-24 md:py-32 bg-brand-bg" data-testid="solution-section">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <p className="text-xs font-medium tracking-[0.25em] text-brand-olive uppercase mb-4">La soluzione</p>
        <h2 className="font-heading text-4xl md:text-5xl text-brand-ink mb-16 max-w-2xl leading-tight">
          Tre passi. Cinque minuti.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 relative">
          {/* linea connettrice */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-brand-line" aria-hidden="true"></div>

          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} className="reveal flex flex-col items-start md:items-center md:text-center relative" data-testid={`solution-step-${i + 1}`}>
                <div className="w-24 h-24 rounded-full bg-white border border-brand-line flex items-center justify-center mb-6 relative z-10">
                  <Icon
                    className={`w-10 h-10 text-brand-olive ${s.animated ? "animate-spin-slow" : ""}`}
                    strokeWidth={1.5}
                  />
                </div>
                <span className="font-heading text-sm text-brand-terra mb-2">{s.num}</span>
                <h3 className="font-heading text-2xl text-brand-ink max-w-[220px]">{s.title}</h3>
              </div>
            );
          })}
        </div>

        <p className="text-lg md:text-xl text-brand-inkSoft text-center mt-20 max-w-2xl mx-auto leading-relaxed" data-testid="solution-footer">
          Niente commerciali. Niente contratti. Niente call.<br />
          <span className="text-brand-ink font-medium">Provala. Se ti convince, paghi.</span>
        </p>
      </div>
    </section>
  );
}
